import { render } from "./JoinAgree.vue?vue&type=template&id=448ed09c&scoped=true"
import script from "./JoinAgree.vue?vue&type=script&lang=js"
export * from "./JoinAgree.vue?vue&type=script&lang=js"

import "./JoinAgree.vue?vue&type=style&index=0&id=448ed09c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-448ed09c"]])

export default __exports__